import type { Plan } from '@kilat/shared/schemas/tenant';

/**
 * Default subscription plans seeded into platformConfig/plans on first deploy.
 * Operators are placed on `starter` by default; super-admin may move them later.
 *
 * Prices in sen (MYR minor units).
 */
export const defaultPlans: readonly Plan[] = [
  {
    id: 'starter',
    name: 'Starter',
    basePrice: 9900, // RM 99.00
    includedOutlets: 1,
    extraOutletPrice: 7900, // RM 79.00 per extra outlet
    currency: 'MYR',
    // Sprint 80 — recruiter epic foundation. Seeded at 0 so existing
    // operators don't get billed signup/activation fees retroactively;
    // super-admin edits live to enable the on-boarding revenue layer.
    fees: { signupSen: 0, activationSen: 0 },
    // Product cross-sell stays OFF for Starter — this is the "off by default"
    // guarantee for every existing tenant (all seeded on `starter`).
    features: { productSales: false },
  },
  {
    // Pro — the upsell tier that unlocks the product cross-sell catalog.
    // NOT the default: new operators land on `starter` (defaultPlanId below),
    // so a tenant only gains `productSales` after a super-admin moves them to
    // `pro`. Even then it stays inert until the operator opts in per-tenant.
    id: 'pro',
    name: 'Pro',
    basePrice: 19900, // RM 199.00
    includedOutlets: 1,
    extraOutletPrice: 7900,
    currency: 'MYR',
    fees: { signupSen: 0, activationSen: 0 },
    features: { productSales: true },
  },
] as const;

export const defaultPlanId = 'starter';
